export default __webpack_public_path__ + "static/media/car3.9600c8fc.png";